import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgDocAiFlat(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M80.275 20.915H24.912c-4.37 0-7.912 3.547-7.912 7.922h55.363c0-4.375 3.543-7.922 7.912-7.922Z"
        fill="#CCD5E1"
      />
      <path
        d="M32.823 92.202c0 4.375 3.543 7.923 7.912 7.923h55.363c-4.37 0-7.912-3.548-7.912-7.923V28.838c0-4.376-3.543-7.923-7.912-7.923H24.912c4.369 0 7.911 3.547 7.911 7.922v63.365Z"
        fill="#F1F5F9"
      />
      <path
        d="M32.023 92.203V28.837c0-3.934-3.185-7.123-7.111-7.123a.8.8 0 1 1 0-1.6c4.812 0 8.712 3.907 8.712 8.723v63.366a.8.8 0 0 1-1.601 0Z"
        fill="#0F172A"
      />
      <path
        d="M40.726 100.125h55.362c4.369 0 7.912-3.548 7.912-7.923H48.637c0 4.375-3.542 7.923-7.911 7.923Z"
        fill="#CCD5E1"
      />
      <path
        d="M80.635 79.085a.8.8 0 0 1 0 1.6h-39.89a.8.8 0 1 1 0-1.6h39.89Zm0-5.707a.8.8 0 0 1 0 1.6h-39.89a.8.8 0 0 1 0-1.6h39.89Zm0-5.707a.8.8 0 0 1 0 1.6h-39.89a.8.8 0 0 1 0-1.6h39.89Zm0-5.706a.8.8 0 1 1 0 1.6h-39.89a.8.8 0 0 1 0-1.6h39.89Zm0-5.707a.8.8 0 0 1 0 1.6h-39.89a.8.8 0 1 1 0-1.6h39.89Zm0-5.707a.8.8 0 0 1 0 1.6H57.84a.8.8 0 0 1 0-1.6h22.795Zm0-5.707a.8.8 0 0 1 0 1.6H57.84a.8.8 0 0 1 0-1.6h22.795Zm0-5.706a.8.8 0 1 1 0 1.6H57.84a.8.8 0 0 1 0-1.6h22.795Zm0-5.707a.8.8 0 1 1 0 1.6H57.84a.8.8 0 0 1 0-1.6h22.795Z"
        fill="#B3C0D0"
      />
      <path
        d="M50.936 37.55a1 1 0 0 1 .76.342v.01c.19.237.275.532.228.837l-1.881 10.824c-.105.532-.589.799-.978.799h-4.92c-.114 0-.238-.01-.295-.029a.974.974 0 0 1-.607-.466l-2.375-4.48a1.012 1.012 0 0 1 .893-1.493h2.289l.95-5.488c.085-.485.503-.847.997-.847h4.92l.019-.01Zm-5.803 7.6-.694 3.966h4.208l-2.1-3.967h-1.424.01Zm-2.945 0 1.254 2.368.408-2.369H42.18h.01Zm4.046-6.326-.873 5.07h1.348c.323 0 .627.162.817.418l.076.114 1.567 2.949 1.482-8.56h-4.426l.01.01Z"
        fill="#78B441"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m88.984 73.018.655-2.007c.152-.466.523-.837.988-.99l2.004-.656c.475-.152.475-.827 0-.989l-2.004-.656a1.551 1.551 0 0 1-.988-.99l-.655-2.006c-.152-.476-.826-.476-.988 0l-.655 2.007a1.552 1.552 0 0 1-.988.989l-2.004.656c-.475.152-.475.828 0 .99l2.004.656c.466.152.836.523.988.989l.655 2.007c.152.475.827.475.988 0Zm7.465 14.98 1.235-3.785a2.912 2.912 0 0 1 1.862-1.865l3.78-1.236c.893-.295.893-1.56 0-1.855l-3.78-1.236a2.912 2.912 0 0 1-1.862-1.865l-1.235-3.785c-.294-.894-1.557-.894-1.852 0l-1.234 3.785a2.912 2.912 0 0 1-1.862 1.865l-3.78 1.236c-.893.295-.893 1.56 0 1.855l3.78 1.236c.883.295 1.577.98 1.861 1.865l1.235 3.785c.295.894 1.558.894 1.852 0Z"
        fill="#007A5F"
      />
    </svg>
  )
}
export default wrapIllustration(SvgDocAiFlat)
